export default __webpack_public_path__ + "static/media/no-results.ba49f1d9.gif";